import { render } from "./TechNotesSection.vue?vue&type=template&id=70a83ce6&scoped=true"
import script from "./TechNotesSection.vue?vue&type=script&lang=js"
export * from "./TechNotesSection.vue?vue&type=script&lang=js"

import "./TechNotesSection.vue?vue&type=style&index=0&id=70a83ce6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70a83ce6"]])

export default __exports__